import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UiButtonComponent } from "../../../../../shared/components/ui-elements/ui-button/ui-button.component";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TermsOfServiceService } from '@core/services/termsOfService/terms-of-service.service';
import { AuthenticationTermsRegisterDialogsComponent } from '@features/authentication/components/dialogs/authentication-terms-register-dialogs/authentication-terms-register-dialogs.component';
import { dialogMdConfig } from '@shared/configs/dialog-config';
import { Terms } from '@features/instances/models/terms.interface';

@Component({
    selector: 'instances-terms-agree-dialog',
    standalone: true,
    templateUrl: './terms-agree-dialog.component.html',
    styleUrls: ['./terms-agree-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        UiButtonComponent,
        TranslatePipe
    ]
})
export class TermsAgreeDialogComponent { 
    terms: Terms;

    constructor(
        private dialogService: MatDialog,
        private dialogRef: MatDialogRef<TermsAgreeDialogComponent>,
        private termsService: TermsOfServiceService,
        @Inject(MAT_DIALOG_DATA) public data: {terms: Terms}
    ) {
        this.terms = data?.terms;
    }


    public openTermOfServiceDialog(): void {
        const dialogRef = this.dialogService.open(AuthenticationTermsRegisterDialogsComponent, {
            ...dialogMdConfig,
            maxWidth: '1100px',
            disableClose: true,
            data: {
                isAgreed: false,
                url: this.terms?.url,
            }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result === 'save') {
            this.agreeToTerms();
          }
        });
    }

    public agreeToTerms(): void {
        this.termsService
            .updateUserTermsVersionApi(this.terms.version)
            .subscribe(() => {
                localStorage.setItem('termsVersion', this.terms.version);
                this.dialogRef.close();
            });
    }
}
